module.exports = __webpack_public_path__ + "img/pencilline.ec5068b3.svg";